import React from 'react';
import { Aside, Overlay, Content, getDirectionOffset } from './style';

const SidePanel = ({
  show,
  hideClick,
  expandWidth,
  maxWidth = false,
  children,
  expandDirection,
}) => (
  <Aside show={show} className={getDirectionOffset(expandDirection)}>
    <Overlay
      show={show}
      onClick={hideClick}
      className={getDirectionOffset(expandDirection)}
    />
    <Content
      expandWidth={expandWidth}
      show={show}
      expandDirection={expandDirection}
      className={getDirectionOffset(expandDirection)}
      maxWidth={maxWidth}
    >
      {children}
    </Content>
  </Aside>
);

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/sidepanel/index.js